// import DateFoodMeal from './DateFoodMeal';

export default {
  // component: DateFoodMeal,
  component: load(() => import(/* webpackChunkName: "Feed-DateFoodMeal" */ './DateFoodMeal')),
  priority: 11,
  permissions: ['SelfService'],
  name: app.translate('routes.home.feed.DateFoodMeal'),
  icon: 'calendar-range',
  drawer: true,
};


